import {
  GET_FEATURED_BEGIN,
  GET_FEATURED_SUCCESS,
  GET_FEATURED_FAIL
} from '../action/featuredAction'

const initialState = {
  loading: false,
  featureds: null,
  error: null,
}

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_FEATURED_BEGIN:
      return {
        loading: true,
        error: null
      }
    case GET_FEATURED_SUCCESS:
      return {
        loading: false,
        featureds: action.payload.data
      }
    case GET_FEATURED_FAIL:
      return {
        loading: false,
        error: action.payload.error
      }
    default:
      return state
  }
}